import { Link } from 'react-router-dom';
import { Phone, Calendar } from 'lucide-react';
import { Button } from '@/components/ui/button';

const MobileCTA = () => {
  return (
    <div data-testid="mobile-cta-bar" className="sticky-cta-mobile">
      <div className="flex items-center gap-3">
        <a href="tel:+18888801455" className="flex-1">
          <Button
            data-testid="mobile-call-btn"
            variant="outline"
            className="w-full flex items-center justify-center gap-2 border-[#4A4A4A] text-[#4A4A4A]"
          >
            <Phone size={18} />
            <span>Call Now</span>
          </Button>
        </a>
        <Link to="/contact" className="flex-1">
          <Button
            data-testid="mobile-book-btn"
            className="w-full btn-primary flex items-center justify-center gap-2"
          >
            <Calendar size={18} />
            <span>Book Now</span>
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default MobileCTA;
